/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefSubscriptionChangeResponse } from '../../models/api-def-subscription-change-response';

export interface OrganizationsCreateOrUpdateSubscription$Params {

/**
 * The ID of the organization
 */
  organizationId: string;
      body: {

/**
 * Stable caller-generated ID reused for every retry of this exact subscription mutation.
 */
'mutationId': string;

/**
 * The ID of the subscription plan to apply
 */
'planId': 'free' | 'startup' | 'business';

/**
 * The pay period for the subscription
 */
'paymentInterval': 'monthly' | 'annually';
}
}

export function organizationsCreateOrUpdateSubscription(http: HttpClient, rootUrl: string, params: OrganizationsCreateOrUpdateSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSubscriptionChangeResponse>> {
  const rb = new RequestBuilder(rootUrl, organizationsCreateOrUpdateSubscription.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefSubscriptionChangeResponse>;
    })
  );
}

organizationsCreateOrUpdateSubscription.PATH = '/organizations/{organizationId}/subscription';
